import { graphql } from 'gatsby';
import * as React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import ContactBridged from '../components/Contact/contact';
import { Layout } from '../components/layout';
import Seo from '../components/seo';

const ContactPage = ({ pageContext }) => {
  const { t } = useTranslation();
  return (
    <Layout>
      <Seo title={t('trans.contact')} lang={pageContext.language} />
      <ContactBridged />
    </Layout>
  );
};
export default ContactPage;

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
